// extracted by mini-css-extract-plugin
export var card = "_bi-1";
export var container = "_bi-0";